module.exports = __webpack_public_path__ + "media/images/logo-bd03636997319b35375f962899b19e8a.svg";